export default __webpack_public_path__ + "static/media/framewhatsapp.be95075b.svg";